export const messages = {
    "wr-dashboard.search.input.hint": "Szukaj",
    "wr-dashboard.search.label.breadcrumb": "Wyniki wyszukiwania",
    "wr-dashboard.search.message.empty": "Brak elementów pasujących do wyszukiwania",
    "wr-dashboard.side-bar.selected.title:plural": "Wybrane pozycje: {count} | Wybrane pozycje: {count} | Wybrane pozycje: {count} | Wybrane pozycje: {count} | Wybrane pozycje: {count}",
    "wr-dashboard.side-bar.backup-type.disk": "Dysk",
    "wr-dashboard.side-bar.backup-type.file": "Plik",
    "wr-dashboard.side-bar.backup-type.notarized": "Notaryzowane pliki i foldery",
    "wr-dashboard.side-bar.backup-type.exchange": "Aplikacja — Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Aplikacja — Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Aplikacja — stan systemu",
    "wr-dashboard.side-bar.backup-type.application": "Aplikacja",
    "wr-dashboard.backups-table.column.name": "Nazwa",
    "wr-dashboard.backups-table.column.size": "Rozmiar",
    "wr-dashboard.backups-table.column.version": "Ostatnia wersja",
    "wr-dashboard.backups-table.action.delete": "Usuń",
    "wr-dashboard.backups-table.message.no-backups": "W chmurze jeszcze nie ma żadnych kopii zapasowych",
    "wr-dashboard.backups-sidebar.label.size": "Rozmiar",
    "wr-dashboard.backups-sidebar.label.type": "Typ",
    "wr-dashboard.backups-sidebar.label.version": "Ostatnia wersja",
    "wr-dashboard.backups-sidebar.label.created": "Utworzono",
    "wr-dashboard.backups-sidebar.label.machine": "Komputer",
    "wr-dashboard.backups-sidebar.label.owner": "Właściciel",
    "wr-dashboard.content-table.column.name": "Nazwa",
    "wr-dashboard.content-table.column.versions": "Wersje",
    "wr-dashboard.content-table.column.volumes": "Woluminy",
    "wr-dashboard.content-table.column.path": "Ścieżka",
    "wr-dashboard.content-table.column.size": "Rozmiar",
    "wr-dashboard.content-table.column.version": "Ostatnia wersja",
    "wr-dashboard.content-table.action.notary-verify": "Zweryfikuj",
    "wr-dashboard.content-table.action.notary-get-crt": "Uzyskaj certyfikat",
    "wr-dashboard.content-table.action.asign": "Wyślij do podpisu",
    "wr-dashboard.content-table.action.versions": "Wersje",
    "wr-dashboard.content-table.action.restore": "Pobierz",
    "wr-dashboard.content-table.label.size": "Rozmiar",
    "wr-dashboard.content-table.label.created": "Utworzono",
    "wr-dashboard.content-table.label.modified": "Zmodyfikowano",
    "wr-dashboard.content-table.message.empty-folder": "Folder jest pusty",
    "wr-dashboard.password-dialog-box.title.backup": "Zaszyfrowana kopia zapasowa",
    "wr-dashboard.password-dialog-box.title.archive": "Archiwum zaszyfrowane",
    "wr-dashboard.password-dialog-box.message.backup": "Podaj hasło, aby uzyskać dostęp do kopii zapasowej {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Podaj hasło, aby uzyskać dostęp do archiwum {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Hasło",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Hasło jest niepoprawne",
    "wr-dashboard.form.button.open": "Otwórz",
    "wr-dashboard.form.button.close": "Zamknij",
    "wr-dashboard.form.button.cancel": "Anuluj",
    "wr-dashboard.form.button.continue": "Kontynuuj",
    "wr-dashboard.form.button.proceed": "Kontynuuj",
    "wr-dashboard.form.button.delete": "Usuń",
    "wr-dashboard.form.button.done": "Gotowe",
    "wr-dashboard.form.button.retry": "Ponów",
    "wr-dashboard.notary.verify.view.status.downloading": "Pobieranie...",
    "wr-dashboard.notary.verify.view.status.validating": "Sprawdzanie poprawności...",
    "wr-dashboard.notary.verify.view.status.pending": "Oczekiwanie na certyfikat...",
    "wr-dashboard.notary.verify.view.status.fail": "Niezgodność certyfikatów...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Uzyskaj certyfikat",
    "wr-dashboard.notary.verify.view.file-info.name": "NAZWA",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "PODPISANY PRZEZ",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "DATA DODANIA DO KOPII ZAPASOWEJ",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "DATA NOTARYZACJI",
    "wr-dashboard.notary.verify.view.button.cancel": "Anuluj",
    "wr-dashboard.notary.verify.view.button.done": "Gotowe",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Nieobsługiwana wersja przeglądarki",
    "wr-dashboard.versions-dialog-box.title": "Wersje pliku {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Wyślij do podpisu",
    "wr-dashboard.asign-dialog-box.message": "Wersja pliku została udostępniona, ale nie można jej wyświetlić, nie dysponując prowadzącym do niej łączem. Przejdź do usługi ASign, aby dodać osoby podpisujące i udostępnić łącze.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Pokaż szczegóły pliku",
    "wr-dashboard.page-not-found.title": "Nie znaleziono strony",
    "wr-dashboard.page-not-found.message.main": "Nie znaleziono szukanej strony.",
    "wr-dashboard.page-not-found.message.description": "Być może łącze jest nieaktualne lub wpisano niepoprawny adres.",
    "wr-dashboard.page-not-found.message.error": "Kod błędu: 404",
    "wr-dashboard.server-error.title": "Serwer jest niedostępny",
    "wr-dashboard.server-error.message": "Serwer nie jest obecnie dostępny. Spróbuj ponownie później.",
    "wr-dashboard.server-error.message.error": "Kod błędu: 500",
    "wr-dashboard.account-menu.action.sign-out": "Wyloguj się",
    "wr-dashboard.breadcrumb.item.machines": "Komputery",
    "wr-dashboard.breadcrumb.item.failed-backups": "Nieprawidłowe kopie zapasowe",
    "wr-dashboard.machines-table.column.name": "Nazwa",
    "wr-dashboard.machines-table.column.size": "Rozmiar",
    "wr-dashboard.machines-table.message.no-machines": "W chmurze jeszcze nie ma żadnych komputerów",
    "wr-dashboard.incomplete-backups.message.status:plural": "Masz {count} nieprawidłowych lub niepełnych kopii zapasowych zajmujących {size} miejsca w magazynie | Masz {count} nieprawidłową lub niepełną kopię zapasową zajmującą {size} miejsca w magazynie | Masz {count} nieprawidłowe lub niepełne kopie zapasowe zajmujące {size} miejsca w magazynie | Masz {count} nieprawidłowych lub niepełnych kopii zapasowych zajmujących {size} miejsca w magazynie | Masz {count} nieprawidłowych lub niepełnych kopii zapasowych zajmujących {size} miejsca w magazynie",
    "wr-dashboard.incomplete-backups.button.view": "Wyświetl kopie zapasowe",
    "wr-dashboard.incomplete-backups.button.delete": "Usuń kopie zapasowe",
    "wr-dashboard.machines-table.message.space-used:plural": "Miejsce zajmowane przez kopie zapasowe: {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Usuń archiwa",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Usuń niepełne archiwa",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Usuń wszystkie niepełne archiwa",
    "wr-dashboard.delete-archive.message": "Czy na pewno chcesz trwale usunąć wybrane archiwa ze wszystkich lokalizacji? Wszystkie te dane zostaną usunięte i nie będzie można ich przywrócić.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Certyfikat oczekuje",
    "wr-dashboard.certificate-pending-dialog-box.message": "Spróbuj ponownie za kilka minut.",
    "wr-dashboard.form.button.ok": "Ok"
};
